import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Route, useRouteMatch } from 'react-router-dom';
import { Switch, useLocation } from 'react-router';
import { RootState } from '../../models/RootState';
import { fetchButtonVariables } from '../../store';
import ExchSportsView from './ExchangeSportsView';
import ExchInplayEventsView from '../ExchInplayEvents/ExchInplayEventsView';
import ExchangeAllMarkets from './ExchangeAllMarkets';
import ExchOutrightsView from '../ExchOutrightsView/ExchOutrightsView';
import UpComingEvents from './UpComingEvents';
import CompetitionsMenu from '../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import RightSideNav from '../../views/CommissionRules/RightSideNav/RightSideNav';
import { IonRow, IonCol } from '@ionic/react';
import {
  isConnected,
  connectToWS,
  unsubscribeAllWsforEvents,
} from '../../webSocket/webSocket';
import './ExchangeSportsHomeView.scss';
import MultimarketView from './MultimarketView';

type StoreProps = {
  loggedIn: boolean;
  fetchButtonVariables: () => void;
  topicUrls: any;
  betFairWSConnected: boolean;
};

const ExchangeSportsBook: React.FC<StoreProps> = (props) => {
  const { loggedIn, fetchButtonVariables, topicUrls, betFairWSConnected } = props;
  const { path } = useRouteMatch();
  const [backupStreamUrl, setBackupStreamUrl] = useState<string>(null);
  const [eventId, setEventId] = useState<string>(null);
  const [inplay, setInplay] = useState<boolean>(false);
  const [showStream, setShowStream] = useState<boolean>(false);
  const [liveStrem, setLiveStrem] = useState<boolean>(false);

  const location = useLocation();
  const pathName = location.pathname;

  useEffect(() => {
    if (loggedIn) {
      fetchButtonVariables();
    }
  }, [loggedIn]);

  // Websocket handler
  useEffect(() => {
    if (loggedIn && topicUrls?.matchOddsBaseUrl) {
      if (!betFairWSConnected) {
        const baseUrlsPayload = {
          matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
          bookMakerAndFancyBaseUrl: topicUrls?.bookMakerBaseUrl,
          premiumBaseUrl: topicUrls?.premiumBaseUrl
        }
        connectToWS(baseUrlsPayload);
      }
      return () => {
        if (betFairWSConnected) {
          unsubscribeAllWsforEvents();
        }
      };
    }
  }, [loggedIn, topicUrls]);

  return (
    <>
      <div className="sport-home-view">
        <IonRow>
          <IonCol sizeMd="1.8" sizeLg="1.8" className="web-view">
            <div className="compt-menu-section">
              <div className="sticky-col">
                <CompetitionsMenu loggedIn={true} />
              </div>
            </div>
          </IonCol>
          <IonCol sizeXs="12" sizeSm="12" sizeMd="7.5" sizeLg="7.5">
            <div className="events-table-section">
              <Switch>
                <Route exact path={path}>
                  <ExchSportsView />
                </Route>
                <Route
                  exact
                  path={`${path}/inplay`}
                  render={() => <ExchInplayEventsView loggedIn={loggedIn} />}
                ></Route>
                <Route
                  exact
                  path={`${path}/multi-markets`}
                  render={() => <MultimarketView />}
                />
                <Route
                  exact
                  path={`${path}/outrights/:eventInfo`}
                  render={() => <ExchOutrightsView loggedIn={loggedIn} />}
                ></Route>
                {/* <Route
                exact
                path={`${path}/binary`}
                render={() => <ExchBinaryView loggedIn={loggedIn} />}
              ></Route> */}
                <Route
                  exact
                  path={`${path}/up/:eventType`}
                  render={() => <UpComingEvents />}
                />
                <Route
                  exact
                  path={`${path}/:eventType`}
                  render={() => <ExchSportsView />}
                />
                <Route
                  exact
                  path={`${path}/:eventType/:competition`}
                  render={() => <ExchSportsView />}
                />
                <Route
                  exact
                  path={`${path}/:eventType/:competition/:eventId/:eventInfo`}
                  render={() => (
                    <ExchangeAllMarkets
                      loggedIn={loggedIn}
                      returnBackupStreamUrl={(url: string) =>
                        setBackupStreamUrl(url)
                      }
                      returnEventId={(eventId: string) => setEventId(eventId)}
                      returnInplayValue={(inplay: boolean) => setInplay(inplay)}
                      returnShouldShowStream={(showStreamML: boolean) => setShowStream(showStreamML)}
                      handleLiveStrem={(liveStrem: boolean) =>
                        setLiveStrem(liveStrem)
                      }
                    />
                  )}
                />
              </Switch>
            </div>
          </IonCol>
          <IonCol sizeMd="2.7" sizeLg="2.7" className="web-view">
            <div className="right-side-ctn web-view">
              <RightSideNav
                backupStreamUrl={backupStreamUrl}
                eventId={eventId}
                inplay={inplay}
                showliveStrem={liveStrem}
                showStream={showStream}
              />
            </div>
          </IonCol>
        </IonRow>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    topicUrls: state?.exchangeSports?.topicUrls,
    betFairWSConnected: state.exchangeSports.betFairWSConnected,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchButtonVariables: () => dispatch(fetchButtonVariables()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeSportsBook);
